'use strict';

(function () {
  'use strict';

  angular.module('msCore').controller('LogoutModalCtrl', LogoutModalCtrl);

  LogoutModalCtrl.$inject = ['close', 'msAuth', 'windowSvc', '$interval', '$log', '$rootScope', '$translate', '$timeout'];

  function LogoutModalCtrl(close, msAuth, windowSvc, $interval, $log, $rootScope, $translate, $timeout) {
    var vm = this;
    vm.updateSession = updateSession;
    vm.closeModal = closeModal;
    vm.logoutMember = logoutMember;
    vm.isSizeSmall = true;
    activate();

    function activate() {
      $rootScope.isModalOpen = true;
      vm.title = 'LogoutModalCtrl';
      vm.LOGOUT_TIME = 120000; // 2 minutes = 120 000 milliseconds
      vm.INTERVAL = 1000;
      vm.timeLeft = vm.LOGOUT_TIME;
      setTime(vm.timeLeft);

      vm.countDown = $interval(function () {
        vm.timeLeft -= vm.INTERVAL;
        setTime(vm.timeLeft);
        vm.getTimeAnnounce();

        if (vm.timeLeft === 0) {
          $interval.cancel(vm.countDown);
          logoutMember();
        }
      }, vm.INTERVAL);
    }

    function setTime(time) {
      vm.minutes = moment.duration(time).minutes();
      vm.seconds = moment.duration(time).seconds();
    }

    vm.getTimeAnnounce = function () {
      return ' \n        ' + getTime(vm.minutes) + ' ' + getTime(vm.minutes, 'minute') + ' \n        ' + getTime(vm.seconds) + ' ' + getTime(vm.seconds, 'second') + '\n      ';
    };

    function getTime(time, timeUnit) {
      if (!time) {
        return '';
      }

      if (!timeUnit) {
        return time;
      }

      if (time > 1 && timeUnit) {
        timeUnit += 's';
      }

      return $translate.instant('common.time.' + timeUnit);
    }

    function updateSession() {
      $interval.cancel(vm.countDown);
      $rootScope.isSessionRestored = true;
      $timeout(function () {
        return delete $rootScope.isSessionRestored;
      }, 2000);
      msAuth.reauth(moment.tz.guess()).then(function () {
        close(false, 200);
      }, function (err) {
        $log.error(err);
        logoutMember();
      });
    }

    function logoutMember() {
      var redirect = windowSvc.getRedirectUrl();
      msAuth.logout();
      if (windowSvc.isLogoutRoute()) {
        windowSvc.windowNavigate('/login');
      } else {
        windowSvc.windowNavigate('/login/?redirecturl=' + redirect);
      }
    }

    function closeModal() {
      $rootScope.isModalOpen = false;
      updateSession();
      // 200ms pause to let ngAnimate hide the modal.
      close(false, 200);
    }
  }
})();